import {LanguageService} from '../original-services/language.service';

export function LocaleFactory(service: LanguageService) {
    return service.getLocale();
}
